import { render, staticRenderFns } from "./NER.vue?vue&type=template&id=38a3d40b&scoped=true&"
import script from "./NER.vue?vue&type=script&lang=js&"
export * from "./NER.vue?vue&type=script&lang=js&"
import style0 from "./NER.vue?vue&type=style&index=0&id=38a3d40b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a3d40b",
  null
  
)

export default component.exports